export const POST_DEPENDENTS_EXCLUSION = 'index/POST_DEPENDENTS_EXCLUSION';
export const POST_CANCEL_DEPENDENTS_EXCLUSION =
  'index/POST_CANCEL_DEPENDENTS_EXCLUSION';
export const POST_FINISH_DEPENDENTS_EXCLUSION =
  'index/POST_FINISH_DEPENDENTS_EXCLUSION';

export const FETCH_DEPENDENTS_EXCLUSION_OF_TICKET =
  'index/FETCH_DEPENDENTS_EXCLUSION_OF_TICKET';
